import { FormBase } from "../form-base";

export class CheckBox extends FormBase<string> {
  controlType = 'checkbox';
  type: string;

  constructor(options: Record<string, any> = {}) {
    super(options);
    this.type = options['type'] || '';
  }
}